var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOjoOcultar24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.75002C8.4879 6.75002 5.43153 8.69921 3.8586 11.5753C3.7138 11.8401 3.7138 12.1598 3.8586 12.4246C4.38561 13.3883 5.07974 14.2486 5.9023 14.9664L7.50475 16.0959L6.70374 17.3619C6.07659 17.0076 5.48873 16.5924 4.94816 16.1245C3.97944 15.2858 3.16202 14.2771 2.54254 13.1443C2.15248 12.431 2.15249 11.5688 2.54256 10.8556C4.36847 7.51689 7.91882 5.25002 12 5.25002C12.9668 5.25002 13.905 5.37741 14.7981 5.61672C15.6321 5.84018 16.426 6.16102 17.1668 6.56617L16.4471 7.88221C15.8096 7.53361 15.1269 7.25773 14.4099 7.06561C13.6423 6.85993 12.8346 6.75002 12 6.75002ZM18.463 8.32249C18.7522 8.02592 19.227 8.01992 19.5236 8.30909C20.2876 9.05405 20.9413 9.91181 21.4575 10.8557C21.8475 11.569 21.8475 12.4312 21.4574 13.1445C19.6315 16.4832 16.0812 18.75 12 18.75C11.0735 18.75 10.1732 18.633 9.31372 18.4126C8.91249 18.3098 8.67062 17.9011 8.7735 17.4999C8.87638 17.0986 9.28505 16.8568 9.68628 16.9596C10.4251 17.1491 11.2002 17.25 12 17.25C15.5121 17.25 18.5685 15.3008 20.1414 12.4247C20.2862 12.1599 20.2862 11.8402 20.1414 11.5755C19.6974 10.7635 19.1347 10.0249 18.4764 9.38306C18.1798 9.09389 18.1738 8.61906 18.463 8.32249Z",
    fill: "#3677DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93414 19.9947C4.22703 20.2876 4.70191 20.2876 4.9948 19.9947L19.9948 4.99469C20.2877 4.70179 20.2877 4.22692 19.9948 3.93403C19.7019 3.64113 19.227 3.64113 18.9341 3.93403L3.93414 18.934C3.64125 19.2269 3.64125 19.7018 3.93414 19.9947Z",
    fill: "#3677DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.75002C10.7574 9.75002 9.75 10.7574 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12C8.25 9.92895 9.92893 8.25002 12 8.25002C12.4142 8.25002 12.75 8.58581 12.75 9.00002C12.75 9.41423 12.4142 9.75002 12 9.75002Z",
    fill: "#3677DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjoOcultar24X24);
export default __webpack_public_path__ + "static/media/OJO_OCULTAR_24X24.f8275f0eb6b4dd317117e60cd0643ff2.svg";
export { ForwardRef as ReactComponent };